<script lang="ts">
  import Dropdown from "$components/+blocks/Dropdown/Dropdown.svelte";
  import Action from "$components/+blocks/Dropdown/fields/Action.svelte";
  import Button from "$components/+blocks/Button/Button.svelte";

  // Create a new style element
  const globalStyle = document.createElement("style");
  const classStyle = document.createElement("style");
</script>

<Dropdown>
  <Button
    let:active
    variant={active ? "active" : "secondary"}
    slot="trigger"
    label="CSS"
    size="small"
  />
  <Action
    title={`${document.head.contains(globalStyle) ? "Disable" : "Enable"} outline all elements`}
    on:click={() => {
      if (document.head.contains(globalStyle)) {
        document.head.removeChild(globalStyle);
        return;
      }
      globalStyle.innerHTML = `* { outline: 1px solid #ff760052; }`;
      document.head.appendChild(globalStyle);
    }}
  />
  <Action
    title={`${document.head.contains(classStyle) ? "Disable" : "Enable"} outline class element`}
    on:click={() => {
      if (document.head.contains(classStyle)) {
        document.head.removeChild(classStyle);
        return;
      }
      const className = prompt("Enter class name");
      classStyle.innerHTML = `.${className} { outline: 1px solid #ff760052;}`;

      document.head.appendChild(classStyle);
    }}
  />
</Dropdown>
